/**
 * Feature Flag for Rebuy Functionality
 *
 * Controls whether rebuy functionality is enabled in the application.
 * Set to false to disable all rebuy UI elements.
 */
export const REBUY_ENABLED = false;
